"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeroBannerComponent = void 0;
var app_1 = require("app");
var KeepTheRhythm_1 = require("../KeepTheRhythm");
var HeroBannerComponent = /** @class */ (function (_super) {
    __extends(HeroBannerComponent, _super);
    function HeroBannerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.selector = ".hero-banner";
        _this.numberOfLines = 4;
        _this.opened = false;
        _this.hbHome = false;
        _this.OnMoreClick = function () {
            var textBlockCurrentHeight = _this.$descriptionText.innerHeight();
            if (!_this.opened) {
                _this.opened = true;
                _this.$info.addClass("hero-banner__info_is-opened");
                _this.$description.css({ "max-height": textBlockCurrentHeight + KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2 });
                setTimeout(function () {
                    _this.$description.addClass("auto-height");
                }, 300);
            }
            else {
                _this.opened = false;
                _this.$info.removeClass("hero-banner__info_is-opened");
                _this.$description.css({ "max-height": textBlockCurrentHeight + KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2 }).removeClass("auto-height");
                setTimeout(function () {
                    _this.$description.css({ "max-height": _this.textBlockHeightCollapsed });
                }, 50);
            }
        };
        return _this;
    }
    HeroBannerComponent.prototype.BeforeInit = function () {
        if (this.$el.hasClass("hero-banner-home")) {
            // HeroBannerHomeComponent
            this.hbHome = true;
            return;
        }
        this.$description = this.$el.find(".hero-banner__info_description");
        this.$title = this.$el.find(".hero-banner__info_title");
        this.$more = this.$el.find(".hero-banner__info_more");
        this.$descriptionText = this.$el.find(".hero-banner__info_description-text");
        this.$info = this.$el.find(".hero-banner__info");
        this.$moreButton = this.$el.find(".hero-banner__info_more-link");
        this.$more.on("click", this.OnMoreClick);
        this.textHeight = KeepTheRhythm_1.KeepTheRhythmComponent.baseline * this.numberOfLines
            + this.$title.outerHeight(true);
        this.textBlockHeightCollapsed = this.textHeight + KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2;
        if (!this.$moreButton.length) {
            this.$description.css({ "max-height": this.textHeight + KeepTheRhythm_1.KeepTheRhythmComponent.baseline * 2 });
        }
    };
    HeroBannerComponent.prototype.OnWindowResizeThrottle = function (windowWidth) {
        if (this.hbHome) {
            return;
        }
        this.ShowMoreButton();
    };
    HeroBannerComponent.prototype.OnPageLoad = function () {
        var _this = this;
        if (this.hbHome) {
            return;
        }
        setTimeout(function () {
            _this.ShowMoreButton();
        }, 500);
    };
    HeroBannerComponent.prototype.OnInit = function () {
        var _this = this;
        if (this.hbHome) {
            return;
        }
        setTimeout(function () {
            _this.ShowMoreButton();
        }, 500);
    };
    HeroBannerComponent.prototype.HasToCollapse = function (blockHeightCurrent) {
        return blockHeightCurrent <= this.textHeight;
    };
    HeroBannerComponent.prototype.ShowMoreButton = function () {
        var textBlockCurrentHeight = this.$descriptionText.innerHeight();
        if (this.$moreButton.length === 1) {
            this.$info.addClass("hero-banner__info_has-button");
        }
        else {
            if (!this.HasToCollapse(textBlockCurrentHeight)) {
                this.$info.addClass("hero-banner__info_is-big");
            }
            else {
                this.$info.removeClass("hero-banner__info_is-big");
            }
        }
    };
    return HeroBannerComponent;
}(app_1.Component));
exports.HeroBannerComponent = HeroBannerComponent;
var component = new HeroBannerComponent();
